module.exports = __webpack_public_path__ + "img/sign_230140654_1.b8e33ef8.png";